import { render, staticRenderFns } from "./SnakeSpinner.vue?vue&type=template&id=5be6f2f2&scoped=true"
import script from "./SnakeSpinner.vue?vue&type=script&lang=js"
export * from "./SnakeSpinner.vue?vue&type=script&lang=js"
import style0 from "./SnakeSpinner.vue?vue&type=style&index=0&id=5be6f2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be6f2f2",
  null
  
)

export default component.exports